<div class="flex items-center justify-center min-h-screen bg-surface-0 dark:bg-surface-900">
    <div class="text-center px-4">
      <h1 class="text-primary text-6xl font-bold mb-4">404</h1>
      <p class="text-xl text-surface-600 dark:text-surface-200 mb-6">
        Trang bạn đang tìm kiếm không tồn tại / không trong phạm vi được xem.
      </p>
      <p-button label="Quay lại" icon="pi pi-home" routerLink="/" />
    </div>
  </div>